import React, { Component } from "react";
import {
  NormalButton,
  NormalSelect,
  NormalCheckbox,
  NormalInput,
  NormalModal,
  NormalTextarea,
  InputSearch,
  NormalTable,
  NormalButtonBackend,
} from "component/common";
import moment from "moment";
// import "./style.scss";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { commonCreateApi, getCommonApi } from "redux/actions/common";
import { withTranslation } from "react-i18next";
import {
  SiteGroups,
  NewSiteGroups,
  ItemSitelists,
  NewItemSitelists,
  Cities,
  States,
  Countries,
  updateCommon,
} from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BsPencilSquare } from "react-icons/bs";
import closeIcon from "assets/images/close.png";
import { Toast } from "service/toast";
import { Document } from "component/Admin/CustomerPlus/CustomerDetailsPlus/Document";
// import { DocumentUpload } from "./DocumentUpload";

export class ImportBalanceClass extends Component {
  state = {
    SiteDetails: [
      {
        label: "Transaction Date",
        enabled: true,
        id: "itemsiteCode",
      },
      {
        label: "Invoice Number",
        enabled: true,
        id: "itemsiteDesc",
      },

      {
        label: "Customer Phone",
        enabled: true,
        id: "itemsiteCode",
      },
      {
        label: "Item No",
        enabled: true,
        id: "itemsiteCode",
      },

      {
        label: "Item Description",
        enabled: true,
        id: "itemsiteDesc",
      },
      {
        label: "Unit Price",
        enabled: true,
        id: "itemsiteCode",
      },
      {
        label: "Total Price",
        enabled: true,
        id: "itemsiteDesc",
      },
      {
        label: "Total Paid",
        enabled: true,
        id: "itemsiteCode",
      },
      {
        label: "Total Balance Amount",
        enabled: true,
        id: "itemsiteDesc",
      },
      {
        label: "Total Outstanding ",
        enabled: true,
        id: "itemsiteDesc",
      },
      {
        label: "Qty",
        enabled: true,
        id: "itemsiteCode",
      },
      {
        label: "Total Balance Qty",
        enabled: true,
        id: "itemsiteCode",
      },
      {
        label: "Sales Staff",
        enabled: true,
        id: "itemsiteDesc",
      },
      {
        label: "Treatment Staff",
        enabled: true,
        id: "itemsiteCode",
      },
      {
        label: "Transaction Type",
        enabled: true,
        id: "itemsiteCode",
      },
      {
        label: "Remarks",
        enabled: true,
        id: "itemsiteDesc",
      },
      {
        label: "Payment Type",
        enabled: true,
        id: "itemsiteDesc",
      },
      {
        label: "Expiry Date",
        enabled: true,
        id: "itemsiteDesc",
      },
      {
        label: "Customer Reference",
        enabled: true,
        id: "itemsiteDesc",
      },
      {
        label: "Customer Name",
        enabled: true,
        id: "itemsiteCode",
      },
      {
        label: "Outlet",
        enabled: true,
        id: "itemsiteDesc",
      },
      {
        label: "Row",
        enabled: true,
        id: "itemsiteDesc",
      },
    ],
    isoption: false,
    iscreation: false,
    islist: false,
    islisttwo: false,
    staffList: [],
    Site_list: [],
    code: null,
    desc: null,
    itemsiteId: null,
    option: [
      { label: 10, value: 10 },
      { label: 25, value: 25 },
      { label: 50, value: 50 },
      { label: 100, value: 100 },
    ],
    city: [],
    country: [],
    state: [],
    site_group: [],
    address: "",
    email: "",
    fax: "",
    phoneone: "",
    phonetwo: "",
    ac_code: "",
    checked: true,
    gst: true,
    post_code: "",
    cityval: "",
    stateval: "",
    countryval: "",
    cityid: "",
    stateid: "",
    countryid: "",
    site_groupval: "",
    isAboutPopModal: false,
    isNewdescPopModal: false,
    newid: "",
    newval: "",
    editid: "",
    editval: "",
    search: "",
    filterdata: [],
    searchone: "",
    filterdataone: [],
    addressedit: "",
    emailedit: "",
    faxedit: "",
    phoneoneedit: "",
    phonetwoedit: "",
    ac_codeedit: "",
    checkededit: true,
    gstedit: true,
    post_codeedit: "",
    cityvaledit: "",
    statevaledit: "",
    countryvaledit: "",
    codeedit: "",
    descedit: "",
    site_groupvaledit: "",
    edit: false,
    image: null,
    is_loading: false,
    images: null,
  };

  sitecontent() {
    this.setState({
      iscreation: !this.state.iscreation,
    });
  }

  listcontent() {
    this.setState({
      islist: !this.state.islist,
    });
  }

  //Sorting

  handleSort = (sortkey, order) => {
    let { staffList, headerDetails, orderBy } = this.state;
    this.setState({
      orderBy: this.state.orderBy == "asc" ? "desc" : "asc",
    });
    console.log("che");
    if (orderBy === "asc") {
      staffList.sort((a, b) =>
        a[sortkey] > b[sortkey] ? 1 : b[sortkey] > a[sortkey] ? -1 : 0
      );
    } else {
      staffList.sort((a, b) =>
        a[sortkey] < b[sortkey] ? 1 : b[sortkey] < a[sortkey] ? -1 : 0
      );
    }
    this.setState({
      staffList,
    });
  };

  //Sorting

  handleSortsecond = (sortkey, order) => {
    let { Site_list, headerDetails, orderBy } = this.state;
    this.setState({
      orderBy: this.state.orderBy == "asc" ? "desc" : "asc",
    });
    console.log("che");
    if (orderBy === "asc") {
      Site_list.sort((a, b) =>
        a[sortkey] > b[sortkey] ? 1 : b[sortkey] > a[sortkey] ? -1 : 0
      );
    } else {
      Site_list.sort((a, b) =>
        a[sortkey] < b[sortkey] ? 1 : b[sortkey] < a[sortkey] ? -1 : 0
      );
    }
    this.setState({
      Site_list,
    });
  };
  componentDidMount = () => {
    // this.Listofsitegroup({});
    this.Listofsitelist({});
    // this.Listofcities({});
    // this.Listofstates({});
    // this.Listofcountry({});
  };
  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  aboutpopup() {
    this.setState({
      isAboutPopModal: !this.state.isAboutPopModal,
    });
  }

  newdescpopup() {
    this.setState({
      isNewdescPopModal: !this.state.isNewdescPopModal,
    });
  }

  Listofsitelist = async () => {
    this.updateState({ is_loading: true });
    await this.props.ItemSitelists().then((res) => {
      let { city } = this.state;
      for (let key of res) {
        city.push({
          value: key.itemsiteCode,
          label: key.itemsiteDesc,
          id: key.itemsiteId,
        });
      }
      this.setState({
        city,
        is_loading: false,
      });
    });
  };

  // handleEdit(id, desc) {
  //   let { editid, editval } = this.state;
  //   editid = id;
  //   editval = desc;
  //   console.log(editid, editval);
  //   this.setState({
  //     editid,
  //     editval,
  //   });
  //   this.aboutpopup();
  // }

  handledesc = ({ target: { value, name } }) => {
    console.log(name);
    let { editval, newid } = this.state;

    if ((name = "desc")) {
      editval = value;
      this.setState({ editval });
    }
    if ((name = "newid")) {
      newid = value;
      this.setState({ newid });
    }
  };

  handledescription = ({ target: { value, name } }) => {
    let { newval } = this.state;

    if ((name = "newdescval")) {
      newval = value;
      this.setState({ newval });
    }
  };

  finaldesc = async (id, desc) => {
    let { editval, newval, newid } = this.state;
    let descJson = {
      code: id,
      description: desc,
      isActive: true,
      isDelete: true,
    };
    await this.props
      .updateCommon(
        `SiteGroups/update?where=%7B%22code%22%3A${id}%7D
    `,
        descJson
      )
      .then((data) => {
        // this.Listofsitegroup({});
        Toast({
          type: "success",
          message: "Updated Successfully",
        });
      });
    this.aboutpopup();
    editval = "";
    newval = "";
    newid = "";
    this.setState({ editval, newval, newid });
  };

  createdesc = async (id, val) => {
    console.log(id, val);
    if (val == "") {
      Toast({
        type: "error",
        message: "Please check required field",
      });
    } else {
      let newreason = {
        code: id,
        description: val,
        isActive: true,
        isDelete: true,
      };
      await this.props
        .NewSiteGroups(newreason)
        .then((data) => {
          // this.Listofsitegroup({});
        })
        .catch((e) => console.log(e));
      this.newdescpopup();
    }
  };
  handleimageChange = (event) => {
    const displayImage = URL.createObjectURL(event.target.files[0]);

    this.setState({
      images: event.target.files[0],
      image: displayImage,
      // updateImage: true,
      // editImage: displayImage,
    });
  };

  createsitelist = async () => {
    let { images, Site_list } = this.state;
    if (images !== null) {
      this.setState({ is_loading: true });
      let formData = new FormData();
      formData.append(`treatment_file`, images);

      this.props
        .commonCreateApi(`treatmentbalanceimport/`, formData)
        .then((res) => {
          console.log(res.failed_rows, "ImageRes");

          this.setState({ Site_list: res.failed_rows, is_loading: false });
          console.log(Site_list, "site");
        });
    }
  };

  updatesitelist = async () => {
    let {
      codeedit,
      descedit,
      count,
      post_codeedit,
      addressedit,
      emailedit,
      faxedit,
      phoneoneedit,
      phonetwoedit,
      ac_codeedit,
      checkededit,
      gstedit,
      cityvaledit,
      statevaledit,
      countryvaledit,
      site_groupvaledit,
      images,
      itemsiteId,
    } = this.state;
    // if (codeedit == null || descedit == null) {
    //   Toast({
    //     type: "error",
    //     message: "Please check rquired field",
    //   });
    // } else {
    let newreason = {
      siteGroupIdId: 1,
      itemSiteCityIdId: this.state.cityid,
      itemSiteCountryIdId: this.state.countryid,
      itemSiteStateIdId: this.state.stateid,
      itemSiteUserIdId: null,
      itemsiteCode: codeedit,
      itemsiteDesc: descedit,
      itemsiteType: "",
      itemPurchasedept: "",
      itemsiteAddress: addressedit,
      itemsitePostcode: post_codeedit,
      itemsiteCity: cityvaledit,
      itemsiteState: statevaledit,
      itemsiteCountry: countryvaledit,
      itemsitePhone1: phoneoneedit,
      itemsitePhone2: phonetwoedit,
      itemsiteFax: faxedit,
      itemsiteEmail: emailedit,
      itemsiteUser: "sys",
      itemsiteDate: new Date(),
      itemsiteTime: new Date(),
      itemsiteIsactive: checkededit,
      itemsiteRefcode: "",
      siteGroup: site_groupvaledit,
      siteIsGst: gstedit,
      accountCode: ac_codeedit,
      ratings: "",
      picPath: "",
      qrcode: "",
      systemlogMdplUpdate: false,
      sitedbconnectionurl: "",
    };
    await this.props
      .updateCommon(
        `ItemSitelists/update?where=%7B%22itemsiteCode%22%3A${JSON.stringify(
          codeedit
        )}%7D 
  `,
        newreason
      )
      .then(() => {
        this.Listofsitelist({});
        this.setState({
          code: null,
          desc: "",

          post_code: "",
          edit: false,
          address: "",
          email: "",
          fax: "",
          phoneone: "",
          phonetwo: "",
          ac_code: null,
          site_groupval: "",
          cityval: "",
          stateval: "",
          countryval: "",
        });
      })
      .catch((e) => console.log(e));

    //  this.newdescpopup();
  };

  temp = ({ target: { value, name } }) => {
    console.log(value, name);
    let {
      code,
      desc,
      count,
      post_code,
      stateid,
      state,
      country,
      countryid,
      address,
      email,
      fax,
      phoneone,
      phonetwo,
      ac_code,
      checked,
      gst,
      cityval,
      stateval,
      countryval,
      site_groupval,
      city,
      cityid,
      codeedit,
      descedit,
      post_codeedit,
      statevaledit,
      countryvaledit,
      addressedit,
      emailedit,
      faxedit,
      phoneoneedit,
      phonetwoedit,
      ac_codeedit,
      checkededit,
      gstedit,
      cityvaledit,
      site_groupvaledit,
      countedit,
    } = this.state;
    if (name == "code") {
      code = value;
      this.setState({ code });
    }
    if (name == "desc") {
      desc = value;
      this.setState({ desc });
    }
    if (name == "count") {
      count = value;
      this.setState({ count });
    }
    if (name == "post_code") {
      post_code = value;
      this.setState({ post_code });
    }
    if (name == "address") {
      address = value;
      this.setState({ address });
    }
    if (name == "email") {
      email = value;
      this.setState({ email });
    }
    if (name == "fax") {
      fax = value;
      this.setState({ fax });
    }
    if (name == "phoneone") {
      phoneone = value;
      this.setState({ phoneone });
    }
    if (name == "phonetwo") {
      phonetwo = value;
      this.setState({ phonetwo });
    }
    if (name == "checked") {
      checked = value;
      this.setState({ checked });
    }
    if (name == "ac_code") {
      ac_code = value;
      this.setState({ ac_code });
    }
    if (name == "gst") {
      gst = value;
      this.setState({ gst });
    }
    if (name == "city") {
      cityval = value;
      this.setState({ cityval });
      for (let key of city) {
        if (key.value == cityval) {
          cityid = key.id;
        }
      }
      this.setState({ cityid });
    }
    if (name == "state") {
      stateval = value;
      this.setState({ stateval });
      console.log(stateval);
      for (let key of state) {
        if (key.value == stateval) {
          stateid = key.id;
        }
      }
      this.setState({ stateid });
      console.log(stateid);
    }
    if (name == "country") {
      countryval = value;
      this.setState({ countryval });
      console.log(countryval);
      for (let key of country) {
        if (key.value == countryval) {
          countryid = key.id;
        }
      }
      this.setState({ countryid });
      console.log(countryid);
    }
    if (name == "site_group") {
      site_groupval = value;
      this.setState({ site_groupval });
    }

    if (name == "codeedit") {
      codeedit = value;
      this.setState({ codeedit });
    }
    if (name == "descedit") {
      descedit = value;
      this.setState({ descedit });
    }
    if (name == "countedit") {
      countedit = value;
      this.setState({ countedit });
    }
    if (name == "post_codeedit") {
      post_codeedit = value;
      this.setState({ post_codeedit });
    }
    if (name == "addressedit") {
      addressedit = value;
      this.setState({ addressedit });
    }
    if (name == "emailedit") {
      emailedit = value;
      this.setState({ emailedit });
    }
    if (name == "faxedit") {
      faxedit = value;
      this.setState({ faxedit });
    }
    if (name == "phoneoneedit") {
      phoneoneedit = value;
      this.setState({ phoneoneedit });
    }
    if (name == "phonetwoedit") {
      phonetwoedit = value;
      this.setState({ phonetwoedit });
    }
    if (name == "checkededit") {
      checkededit = value;
      this.setState({ checkededit });
    }
    if (name == "ac_codeedit") {
      ac_codeedit = value;
      this.setState({ ac_codeedit });
    }
    if (name == "gstedit") {
      gstedit = value;
      this.setState({ gstedit });
    }
    if (name == "cityvaledit") {
      cityvaledit = value;
      this.setState({ cityvaledit });
      for (let key of city) {
        if (key.value == cityvaledit) {
          cityid = key.id;
        }
      }
      this.setState({ cityid });
    }
    if (name == "statevaledit") {
      statevaledit = value;
      this.setState({ statevaledit });
      console.log(statevaledit);
      for (let key of state) {
        if (key.value == statevaledit) {
          stateid = key.id;
        }
      }
      this.setState({ stateid });
      console.log(stateid);
    }
    if (name == "countryvaledit") {
      countryvaledit = value;
      this.setState({ countryvaledit });
      console.log(countryvaledit);
      for (let key of country) {
        if (key.value == countryvaledit) {
          countryid = key.id;
        }
      }
      this.setState({ countryid });
      console.log(countryid);
    }
    if (name == "site_groupvaledit") {
      site_groupvaledit = value;
      this.setState({ site_groupvaledit });
    }
  };

  handlecheckbox = async (item) => {
    let { staffList } = this.state;
    for (let i = 0; i <= staffList.length - 1; i++) {
      if (staffList[i].code == item) {
        staffList[i].isActive = !staffList[i].isActive;
        let descJson = {
          code: staffList[i].code,
          description: staffList[i].description,
          isActive: staffList[i].isActive,
          isDelete: true,
        };
        await this.props
          .updateCommon(
            `SiteGroups/update?where=%7B%22code%22%3A${item}%7D
    `,
            descJson
          )
          .then((data) => {
            // this.Listofsitegroup({});
          });
      }
    }
  };

  //************Searching option **********//
  filterByName = ({ target: { value, name } }) => {
    console.log(value, name);
    let { staffList, filterdata, search } = this.state;
    if (name == "search") {
      search = value;
      this.setState({ search });
      console.log(search);
    }
    if (search !== "") {
      filterdata = staffList.filter((item) => {
        console.log(
          Object.values(item)
            .join("")
            .toLowerCase()
            .includes(search.toLowerCase())
        );
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(search.toLowerCase());
      });
      this.setState({ filterdata });
    }

    console.log(filterdata);
  };

  //************Searching option **********//
  filterBysite = ({ target: { value, name } }) => {
    console.log(value, name);
    let { Site_list, filterdataone, searchone } = this.state;
    if (name == "search") {
      searchone = value;
      this.setState({ searchone });
    }
    if (searchone !== "") {
      filterdataone = Site_list.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchone.toLowerCase());
      });
    }
    this.setState({ filterdataone });
    console.log(filterdataone);
  };
  componentDidUpdate(prevProps, prevState) {
    console.log(prevProps, prevState, "PrevProps");
    // Check if the itemsiteId has changed from the previous state
    if (prevState.itemsiteId !== this.state.itemsiteId) {
      // Perform any actions here that should happen when itemsiteId changes
      // For example, you can call the <Document /> component here
      // or trigger any other related actions
      console.log("itemsiteId has changed:", this.state.itemsiteId);
    }
  }

  handleedit = async (itemcode) => {
    let {
      edit,
      addressedit,
      emailedit,
      faxedit,
      phoneoneedit,
      phonetwoedit,
      ac_codeedit,
      checkededit,
      gstedit,
      post_codeedit,
      cityvaledit,
      statevaledit,
      countryvaledit,
      codeedit,
      descedit,
      site_groupvaledit,
      cityid,
      stateid,
      countryid,
      itemsiteId,
      temp,
      image,
    } = this.state;
    edit = true;
    this.setState({ edit });
    console.log(edit);
    await this.props.ItemSitelists().then((res) => {
      console.log(res, "response");

      let objIndex = res.findIndex((obj) => obj.itemsiteCode == itemcode);
      temp = res[objIndex];
      this.setState({
        temp,
      });
      console.log(temp, "tempIndex");
      itemsiteId = temp.itemsiteId;
      addressedit = temp.itemsiteAddress;
      emailedit = temp.itemsiteEmail;
      faxedit = temp.itemsiteFax;
      phoneoneedit = temp.itemsitePhone1;
      phonetwoedit = temp.itemsitePhone2;
      ac_codeedit = temp.accountCode;
      checkededit = temp.itemsiteIsactive;
      gstedit = temp.siteIsGst;
      post_codeedit = temp.itemsitePostcode;
      cityvaledit = temp.itemsiteCity;
      statevaledit = temp.itemsiteState;
      countryvaledit = temp.itemsiteCountry;
      codeedit = temp.itemsiteCode;
      descedit = temp.itemsiteDesc;
      site_groupvaledit = temp.siteGroup;
      cityid = temp.itemSiteCityIdId;
      countryid = temp.itemSiteCountryIdId;
      stateid = temp.itemSiteStateIdId;

      this.setState({
        itemsiteId,
        addressedit,
        emailedit,
        faxedit,
        phoneoneedit,
        phonetwoedit,
        ac_codeedit,
        checkededit,
        gstedit,
        post_codeedit,
        cityvaledit,
        statevaledit,
        countryvaledit,
        codeedit,
        descedit,
        site_groupvaledit,
        cityid,
        stateid,
        countryid,
      });
      this.props.getCommonApi(`titleimage/${itemsiteId}/`).then((res) =>
        this.setState({
          image: res.data.logo_pic,
        })
      );
    });
    this.setState({
      iscreation: true,
    });
  };
  handleupdates = async () => {
    let {
      edit,
      addressedit,
      emailedit,
      faxedit,
      phoneoneedit,
      phonetwoedit,
      ac_codeedit,
      checkededit,
      gstedit,
      post_codeedit,
      cityvaledit,
      statevaledit,
      countryvaledit,
      codeedit,
      descedit,
      site_groupvaledit,
    } = this.state;
    let descJson = {
      siteGroupIdId: 0,
      itemSiteCityIdId: this.state.cityid,
      itemSiteCountryIdId: this.state.countryid,
      itemSiteStateIdId: this.state.stateid,
      itemSiteUserIdId: 253,
      itemsiteCode: codeedit,
      itemsiteDesc: descedit,
      itemsiteType: "",
      itemPurchasedept: "",
      itemsiteAddress: addressedit,
      itemsitePostcode: post_codeedit,
      itemsiteCity: cityvaledit,
      itemsiteState: statevaledit,
      itemsiteCountry: countryvaledit,
      itemsitePhone1: phoneoneedit,
      itemsitePhone2: phonetwoedit,
      itemsiteFax: faxedit,
      itemsiteEmail: emailedit,
      itemsiteUser: "sys",
      itemsiteDate: new Date(),
      itemsiteTime: new Date(),
      itemsiteIsactive: checkededit,
      itemsiteRefcode: "",
      siteGroup: site_groupvaledit,
      siteIsGst: gstedit,
      accountCode: ac_codeedit,
      ratings: "",
      picPath: "",
      qrcode: "",
      systemlogMdplUpdate: false,
      sitedbconnectionurl: "",
    };
    await this.props
      .updateCommon(
        `ItemSitelists/update?where=%7B%22itemsiteCode%22%3A%20%22${this.state.codeedit}%22%7D
          `,
        descJson
      )
      .then((data) => {
        this.Listofsitelist({});
        Toast({
          type: "success",
          message: "Updated Successfully",
        });
      });
    this.sitecontent();
  };

  render() {
    let {
      SiteDetails,
      pageMeta,
      staffList,
      is_loading,
      code,
      desc,
      iscreation,
      islist,
      islisttwo,
      Site_list,
      post_code,
      address,
      email,
      fax,
      phoneone,
      phonetwo,
      ac_code,
      checked,
      gst,
      city,
      country,
      state,
      cityval,
      stateval,
      countryval,
      site_groupval,
      site_group,
      isAboutPopModal,
      isNewdescPopModal,
      newid,
      newval,
      editid,
      editval,
      search,
      filterdata,
      searchone,
      filterdataone,
      addressedit,
      emailedit,
      faxedit,
      phoneoneedit,
      phonetwoedit,
      ac_codeedit,
      checkededit,
      gstedit,
      post_codeedit,
      cityvaledit,
      statevaledit,
      countryvaledit,
      codeedit,
      descedit,
      edit,
      image,
      itemsiteId,
      site_groupvaledit,
    } = this.state;
    console.log(itemsiteId, "itemSiteId");
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid tax bg-white">
          <div className="row">
            <h4 className="mt-3 text-center col-12 text-md-left label-head">
              {t("Import Balance")}
            </h4>
          </div>
          <div
            className="d-flex justify-content-between p-3 itemstatusgroup"
            onClick={() => this.sitecontent()}
          >
            <p>{t("Import Balance ")}</p>
            <div className="icons">
              {iscreation == false ? <AiOutlinePlus /> : <AiOutlineMinus />}
            </div>
          </div>
          {edit == false ? (
            <>
              {iscreation == true ? (
                <div className="container-fluid roomcontent">
                  <div className="row">
                    <div className="col-12 d-flex">
                      <div className="mt-3 col-sm-12 col-lg-5 col-xl-5 col-md-5">
                        <p>{t("Select Site")}</p>
                        <div className="input-group">
                          <NormalSelect
                            options={city}
                            value={cityval}
                            onChange={this.temp}
                            name="city"
                          />
                        </div>
                      </div>
                      <div className="mt-3 col-sm-12 col-lg-5 col-xl-5 col-md-5">
                        <p>{t("Select File")}</p>
                        <div className="input-group mt-2">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(event) => this.handleimageChange(event)}
                          />
                        </div>
                      </div>
                      {/* <div className="mt-3 col-sm-12 col-lg-4 col-xl-4 col-md-4">
                       
                      </div> */}
                    </div>
                  </div>

                  <div className="mt-3 col-12 col-md-2 p-0">
                    <NormalButtonBackend
                      mainbg={true}
                      label={"Import"}
                      onClick={() => this.createsitelist()}
                    />
                  </div>
                  {is_loading ? (
                    <div class="d-flex mt-5 align-items-center justify-content-center">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {Site_list.length > 0 ? (
                        <div>
                          <h5 className="mt-3 label-head col-12 text-center text-md-left text-lg-left p-0">
                            {t("Failed Import Rows")}
                          </h5>
                          {searchone.length > 0 ? (
                            <div className="tab-table-content">
                              <div className="py-4">
                                <div className="table-container">
                                  <NormalTable
                                    headerDetails={SiteDetails}
                                    queryHandler={this.handlePagination}
                                    pageMeta={pageMeta}
                                  >
                                    {is_loading ? (
                                      <tr>
                                        <td colSpan="7">
                                          <div class="d-flex mt-5 align-items-center justify-content-center">
                                            <div
                                              class="spinner-border"
                                              role="status"
                                            >
                                              <span class="sr-only">
                                                Loading...
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    ) : filterdataone.length > 0 ? (
                                      filterdataone.map(
                                        (
                                          { itemsiteCode, itemsiteDesc },
                                          index
                                        ) => {
                                          return (
                                            <tr key={index}>
                                              <td>
                                                <div
                                                  className="text-left text-primary cursor-pointer"
                                                  onClick={() =>
                                                    this.handleedit(
                                                      itemsiteCode
                                                    )
                                                  }
                                                >
                                                  {itemsiteCode}
                                                </div>
                                              </td>
                                              <td>
                                                <div className="text-left">
                                                  {itemsiteDesc}
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )
                                    ) : null}
                                  </NormalTable>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="py-4">
                              <div className="table-container">
                                <NormalTable
                                  headerDetails={SiteDetails}
                                  queryHandler={this.handlePagination}
                                  pageMeta={pageMeta}
                                >
                                  {is_loading ? (
                                    <tr>
                                      <td colSpan="7">
                                        <div class="d-flex mt-5 align-items-center justify-content-center">
                                          <div
                                            class="spinner-border"
                                            role="status"
                                          >
                                            <span class="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ) : Site_list.length > 0 ? (
                                    Site_list.map((list, index) => {
                                      console.log(list, "list");
                                      return (
                                        <tr key={index}>
                                          <td>
                                            <div
                                              className="text-left  cursor-pointer"
                                              // onClick={() =>
                                              //   this.handleedit(itemsiteCode)
                                              // }
                                            >
                                              {moment(
                                                list["Transaction Date"]
                                              ).format("DD-MM-YYYY")}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left">
                                              {list["Invoice Number"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div
                                              className="text-left  cursor-pointer"
                                              // onClick={() =>
                                              //   this.handleedit(itemsiteCode)
                                              // }
                                            >
                                              {list["Customer Phone"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left">
                                              {list["Item No"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div
                                              className="text-left  cursor-pointer"
                                              // onClick={() =>
                                              //   this.handleedit(itemsiteCode)
                                              // }
                                            >
                                              {list["Item Description"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left">
                                              {list["Unit Price"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left  cursor-pointer">
                                              {list["Total Price"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left">
                                              {list["Total Paid"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left  cursor-pointer">
                                              {list["Total Balance Amount"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left">
                                              {list["Total Outstanding"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left  cursor-pointer">
                                              {list["Qty"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left">
                                              {list["Total Balance Qty"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left  cursor-pointer">
                                              {list["Sales Staff"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left">
                                              {list["Treatment Staff"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left  cursor-pointer">
                                              {list["Transaction Type"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left">
                                              {list["Remarks"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left  cursor-pointer">
                                              {list["Payment type"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left">
                                              {list["Expiry Date"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left  cursor-pointer">
                                              {list["Customer Reference"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left">
                                              {list["Customer Name"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left  cursor-pointer">
                                              {list["Outlet"]}
                                            </div>
                                          </td>
                                          <td>
                                            <div className="text-left">
                                              {list["row"]}
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : null}
                                </NormalTable>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <h5 className="mt-3 label-head col-12 text-center text-md-left text-lg-left p-0">
                          {t("No Failed Rows ")}
                        </h5>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              {iscreation == true ? (
                <div className="container-fluid roomcontent">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="mt-3">
                        <p>
                          {t("Site Code")}
                          <span style={{ color: "red" }}>*</span>
                        </p>
                        <div className="input-group">
                          <NormalInput
                            value={codeedit}
                            name="codeedit"
                            onChange={this.temp}
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <p>
                          {t("Site Desc")}
                          <span style={{ color: "red" }}>*</span>
                        </p>
                        <div className="input-group">
                          <NormalInput
                            value={descedit}
                            name="descedit"
                            onChange={this.temp}
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <p>{t("City")}</p>
                        <div className="input-group">
                          <NormalSelect
                            options={city}
                            value={cityvaledit}
                            onChange={this.temp}
                            name="cityedit"
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <p>{t("State")}</p>
                        <div className="input-group">
                          <NormalSelect
                            options={state}
                            value={statevaledit}
                            onChange={this.temp}
                            name="stateedit"
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <p>{t("Country")}</p>
                        <div className="input-group">
                          <NormalSelect
                            options={country}
                            value={countryvaledit}
                            onChange={this.temp}
                            name="countryedit"
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <p>{t("PostCode")}</p>
                        <div className="input-group">
                          <NormalInput
                            value={post_codeedit}
                            name="post_codeedit"
                            onChange={this.temp}
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <p>{t("Address")}</p>
                        <div className="input-group">
                          <NormalTextarea
                            onChange={this.temp}
                            value={addressedit}
                            name="addressedit"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="mt-3">
                        <p>{t("E-Mail")}</p>
                        <div className="input-group">
                          <NormalInput
                            value={emailedit}
                            name="emailedit"
                            onChange={this.temp}
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <p>{t("Fax")}</p>
                        <div className="input-group">
                          <NormalInput
                            value={faxedit}
                            name="faxedit"
                            onChange={this.temp}
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <p>{t("Phone 1")}</p>
                        <div className="input-group">
                          <NormalInput
                            value={phoneoneedit}
                            type="tel"
                            name="phoneoneedit"
                            onChange={this.temp}
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <p>{t("Phone 2")}</p>
                        <div className="input-group">
                          <NormalInput
                            value={phonetwoedit}
                            type="tel"
                            name="phonetwordit"
                            onChange={this.temp}
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <p>{t("Site Group")}</p>
                        <div className="input-group">
                          <NormalSelect
                            options={site_group}
                            value={site_groupvaledit}
                            onChange={this.temp}
                            name="site_groupedit"
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <p>{t("Account Code")}</p>
                        <div className="input-group">
                          <NormalInput
                            value={ac_codeedit}
                            name="ac_codeedit"
                            onChange={this.temp}
                          />
                        </div>
                      </div>

                      <div className="mt-3 col-12 d-flex p-0">
                        <div className="d-flex input-group col-12 col-md-3">
                          <NormalCheckbox
                            name="gstedit"
                            checked={gstedit}
                            onChange={this.temp}
                          />
                          <p>{t("GST Active")}</p>
                        </div>
                        <div className="d-flex input-group col-12 col-md-3">
                          <NormalCheckbox
                            name="checkededit"
                            checked={checkededit}
                            onChange={this.temp}
                          />
                          <p>{t(" Active")}</p>
                        </div>
                      </div>
                      <div className="mt-3 ml-2">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(event) => this.handleimageChange(event)}
                        />
                      </div>
                      <div className="mt-3 ml-2 imagecontainer">
                        <img src={image} alt="title" width="150" height="100" />
                      </div>
                    </div>
                    {itemsiteId !== null && (
                      <div className="col-12 col-md-12  col-sm-12">
                        <Document id={itemsiteId} backend></Document>
                      </div>
                    )}
                    <div className="mt-3 col-12 col-md-3 p-0">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"Update"}
                        onClick={() => this.updatesitelist()}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          )}
        </div>
        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "80%" }}
          modal={isAboutPopModal}
          handleModal={() => this.aboutpopup()}
        >
          <div className="col-12 mx-auto">
            <div className="d-flex justify-content-end">
              <img
                onClick={() => this.aboutpopup()}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>
          <div className="col-12">
            <div className="text-center">
              <h5> EDIT DESCRIPTION </h5>
            </div>
            <div className="col-12">
              <div>
                <h6>Code</h6>
                <NormalInput value={editid} disabled={true} />
              </div>
              <div className="mt-2">
                <h6>Name</h6>
                <NormalInput
                  value={editval}
                  name="desc"
                  onChange={this.handledesc}
                />
              </div>
              <div className="d-flex mt-4">
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Cancel"
                    onClick={() => this.aboutpopup()}
                  />
                </div>
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Done"
                    onClick={() => this.finaldesc(editid, editval)}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>

        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "80%" }}
          modal={isNewdescPopModal}
          handleModal={() => this.newdescpopup()}
        >
          <div className="col-12 mx-auto">
            <div className="d-flex justify-content-end">
              <img
                onClick={() => this.aboutpopup()}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>
          <div className="col-12">
            <div className="text-center">
              <h5> ADD SITE GROUP</h5>
            </div>
            <div className="col-12">
              <div className="">
                <h6>Code</h6>
                <NormalInput
                  value={newid}
                  name="newid"
                  onChange={this.handledesc}
                  disabled={true}
                />
              </div>
              <div className="mt-2">
                <h6>NAME</h6>
                <NormalInput
                  value={newval}
                  name="newdescval"
                  onChange={this.handledescription}
                />
              </div>
              <div className="d-flex mt-4">
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Cancel"
                    onClick={() => this.newdescpopup()}
                  />
                </div>
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Done"
                    onClick={() => this.createdesc(newid, newval)}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      SiteGroups,
      NewSiteGroups,
      ItemSitelists,
      NewItemSitelists,
      Cities,
      States,
      Countries,
      updateCommon,
      commonCreateApi,
      getCommonApi,
    },
    dispatch
  );
};

export const ImportBalance = withTranslation()(
  connect(null, mapDispatchToProps)(ImportBalanceClass)
);
